export default __webpack_public_path__ + "static/ups_w.8e1124f016ad90e402d5f053452a626d.png";